import createTableStore from "ds/components/Table/store/useTableStore";

import { SCAN_RUNS_COLUMN_CONFIG, SCAN_RUNS_COLUMNS_STORAGE_KEY } from "./constants";

const useScanRunsTableStore = createTableStore({
  storageKey: SCAN_RUNS_COLUMNS_STORAGE_KEY,
  config: SCAN_RUNS_COLUMN_CONFIG,
});

export default useScanRunsTableStore;
